// Common ICD-10 codes for quick lookup
export const commonICD10Codes = [
  // Diabetes
  { code: 'E11.9', description: 'Type 2 diabetes mellitus without complications' },
  { code: 'E11.65', description: 'Type 2 diabetes mellitus with hyperglycemia' },
  { code: 'E10.9', description: 'Type 1 diabetes mellitus without complications' },
  { code: 'E11.22', description: 'Type 2 diabetes mellitus with diabetic chronic kidney disease' },
  { code: 'E11.40', description: 'Type 2 diabetes mellitus with diabetic neuropathy, unspecified' },
  
  // Hypertension
  { code: 'I10', description: 'Essential (primary) hypertension' },
  { code: 'I11.9', description: 'Hypertensive heart disease without heart failure' },
  { code: 'I12.9', description: 'Hypertensive chronic kidney disease with stage 1 through stage 4 chronic kidney disease' },
  { code: 'I13.10', description: 'Hypertensive heart and chronic kidney disease without heart failure' },
  
  // Hyperlipidemia
  { code: 'E78.5', description: 'Hyperlipidemia, unspecified' },
  { code: 'E78.0', description: 'Pure hypercholesterolemia' },
  { code: 'E78.1', description: 'Pure hyperglyceridemia' },
  { code: 'E78.2', description: 'Mixed hyperlipidemia' },
  
  // Respiratory
  { code: 'J44.1', description: 'Chronic obstructive pulmonary disease with (acute) exacerbation' },
  { code: 'J45.909', description: 'Unspecified asthma, uncomplicated' },
  { code: 'J18.9', description: 'Pneumonia, unspecified organism' },
  { code: 'J06.9', description: 'Acute upper respiratory infection, unspecified' },
  
  // Mental Health
  { code: 'F41.1', description: 'Generalized anxiety disorder' },
  { code: 'F32.9', description: 'Major depressive disorder, single episode, unspecified' },
  { code: 'F33.1', description: 'Major depressive disorder, recurrent, moderate' },
  { code: 'F10.20', description: 'Alcohol dependence, uncomplicated' },
  
  // Pain
  { code: 'M79.3', description: 'Panniculitis, unspecified' },
  { code: 'M54.5', description: 'Low back pain' },
  { code: 'M79.1', description: 'Myalgia' },
  { code: 'M25.511', description: 'Pain in right shoulder' },
  { code: 'M25.561', description: 'Pain in right knee' },
  
  // Cardiovascular
  { code: 'I25.10', description: 'Atherosclerotic heart disease of native coronary artery without angina pectoris' },
  { code: 'I48.91', description: 'Unspecified atrial fibrillation' },
  { code: 'I50.9', description: 'Heart failure, unspecified' },
  
  // Obesity
  { code: 'E66.9', description: 'Obesity, unspecified' },
  { code: 'E66.01', description: 'Morbid (severe) obesity due to excess calories' },
  
  // Kidney Disease
  { code: 'N18.3', description: 'Chronic kidney disease, stage 3 (moderate)' },
  { code: 'N18.4', description: 'Chronic kidney disease, stage 4 (severe)' },
  { code: 'N18.5', description: 'Chronic kidney disease, stage 5' },
  
  // Other Common
  { code: 'R53.83', description: 'Other fatigue' },
  { code: 'R07.9', description: 'Chest pain, unspecified' },
  { code: 'R50.9', description: 'Fever, unspecified' },
  { code: 'R51', description: 'Headache' },
  { code: 'R10.9', description: 'Unspecified abdominal pain' },
  { code: 'R06.02', description: 'Shortness of breath' },
  { code: 'R11.0', description: 'Nausea' },
  { code: 'K21.9', description: 'Gastro-esophageal reflux disease without esophagitis' },
  { code: 'Z79.4', description: 'Long term (current) use of insulin' },
  { code: 'Z79.84', description: 'Long term (current) use of oral hypoglycemic drugs' }
];

// Function to search ICD-10 codes
export function searchICD10Codes(query) {
  if (!query || query.length < 2) return [];
  
  const lowerQuery = query.toLowerCase();
  return commonICD10Codes.filter(item =>
    item.code.toLowerCase().includes(lowerQuery) ||
    item.description.toLowerCase().includes(lowerQuery)
  );
}
